import { Progress } from "antd";
import theme from "utils/themeVars";

const ProgressBar = (props) => {
  const {
    value,
    highColor = theme["primary-color"],
    lowColor = theme["error-color"],
    threshold = 50,
    showPercentage = false,
    ...rest
  } = props;
  return (
    <Progress
      percent={value}
      strokeColor={value < threshold ? lowColor : highColor}
      showInfo={showPercentage}
      {...rest}
    />
  );
};

export default ProgressBar;
